import { createActionCreator, createReducer } from 'deox';
import { BackendSettings } from 'api';
import { AppState } from 'types/AppState';

export type SettingsState = BackendSettings & { isFetched: boolean };

const defaultSettingsState: SettingsState = {
  isFetched: false,
  transitions: {
    fadeDuration: 0,
    wipeDiagonalDuration: 0
  }
};

export const fetchSettings = createActionCreator('SETTINGS/FETCH');
export const updateSettings = createActionCreator(
  'SETTINGS/UPDATE',
  resolve => (payload: Partial<SettingsState>) => resolve(payload)
);

export const settings = createReducer(defaultSettingsState, handle => [
  handle(updateSettings, (state, { payload }) => ({ ...state, ...payload }))
]);

export const getSettings = (key: keyof BackendSettings) => (
  state: AppState
): BackendSettings[keyof BackendSettings] => state.settings[key];

export const isSettingsFetched = (state: AppState): boolean => state.settings.isFetched;
